export default "__VITE_ASSET__DSvg1nHx__"